(function () {
  const grid     = document.querySelector('[data-infinite-grid]');
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  const loader   = document.getElementById('infinite-loader');
  if (!grid || !sentinel) { console.log('[INFINITE] stop: no grid/sentinel'); return; }

  let nextUrl = getNextUrl(document);
  let loading = false;
  const loadedUrls = new Set();
  let pageCount = 0;
  const MAX_PAGES = 50;

  if (!nextUrl) { cleanup(true, 'no next at start'); return; }

  // ---- Observer
  const io = new IntersectionObserver(onIntersect, { rootMargin: '600px 0px 600px 0px' });
  io.observe(sentinel);
  console.log('[INFINITE] start, next:', nextUrl);

  // ---- Déclenchement immédiat si déjà visible
  if (isElementInViewport(sentinel)) {
    onIntersect([{ isIntersecting: true }]);
  }

  // ---- Fallback “near bottom”
  let fallbackTick = 0;
  const fallback = () => {
    // throttle léger
    const now = Date.now();
    if (now - fallbackTick < 200) return;
    fallbackTick = now;

    const nearBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 800);
    if (nearBottom && !loading && nextUrl) {
      onIntersect([{ isIntersecting: true }]);
    }
  };
  window.addEventListener('scroll', fallback, { passive: true });
  window.addEventListener('resize', fallback);

  // ---- Handler
  async function onIntersect(entries) {
    const visible = entries.some(e => e.isIntersecting);
    if (!visible || loading || !nextUrl) return;

    if (loadedUrls.has(nextUrl)) { cleanup(true, 'duplicate next'); return; }
    if (pageCount >= MAX_PAGES) { cleanup(true, 'max pages hit'); return; }

    loading = true;
    toggleLoader(true);
    console.log('[INFINITE] fetch:', nextUrl);

    try {
      const html = await fetch(nextUrl, { credentials: 'same-origin' }).then(r => r.text());
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid = doc.querySelector('[data-infinite-grid]');
      if (!nextGrid) { cleanup(true, 'no next grid'); return; }

      const newItems = nextGrid.querySelectorAll('li.grid__item');
      console.log('[INFINITE] items found:', newItems.length);
      if (!newItems.length) { cleanup(true, 'no items'); return; }

      newItems.forEach(el => grid.appendChild(el));
      loadedUrls.add(nextUrl);
      pageCount++;

      const updatedNext = getNextUrl(doc);
      console.log('[INFINITE] next ->', updatedNext);
      if (!updatedNext || updatedNext === nextUrl) {
        cleanup(true, 'no further next');
      } else {
        nextUrl = updatedNext;
        // relance le fallback pour la page suivante (si on est déjà bas)
        fallback();
      }
    } catch (err) {
      console.error('[INFINITE] error:', err);
      cleanup(true, 'fetch error');
    } finally {
      loading = false;
      toggleLoader(false);
    }
  }

  // ---- Utils
  function getNextUrl(doc) {
    const linkNext = doc.querySelector('link[rel="next"]');
    if (linkNext && linkNext.href) return linkNext.href;
    const aNext = doc.querySelector('.pagination a[rel="next"], .pagination .next a, a.pagination__item--next');
    return aNext ? aNext.href : null;
  }

  function toggleLoader(show) {
    if (!loader) return;
    loader.hidden = !show; // [hidden]{display:none!important;}
  }

  function cleanup(removeLoader, reason) {
    try { io.unobserve(sentinel); } catch(_) {}
    window.removeEventListener('scroll', fallback);
    window.removeEventListener('resize', fallback);
    if (sentinel && sentinel.parentNode) sentinel.remove();
    if (removeLoader && loader && loader.parentNode) loader.remove();
    nextUrl = null;
    console.log('[INFINITE] done:', reason);
  }

  function isElementInViewport(el) {
    const r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || document.documentElement.clientHeight) &&
           r.bottom > 0;
  }
})();
